/** tagm (Tags page): English + Arabic (Arabic is a draft for native review). */
const en = {
  "newTag": "New tag",
  "newTagHint": "A tag exists while players or groups have it. Name it and choose who gets it.",
  "tagName": "Tag name",
  "tagNamePh": "e.g. Lobby, East region, Drive-thru",
  "groupsLabel": "Player groups",
  "pickSomeone": "Choose at least one player or group.",
  "alreadyExists": "#{tag} already exists: the players and groups you choose are added to it.",
  "addToExisting": "Add to tag",
  "create": "Create tag",
  "created": "#{tag} created.",
  "addedExisting": "Added to #{tag}.",
  "title": "Tags",
  "intro": "Player tags group players for publishing and restrictions. See where each tag is used and change it everywhere at once.",
  "search": "Search tags",
  "lookAlikes": "1 tag looks like another | {n} tags look like others",
  "none": "No tags yet",
  "noneHint": "Add tags to players or player groups, then publish content to a tag.",
  "noMatch": "No tags match “{q}”.",
  "nPlayers": "{n} player | {n} players",
  "nGroups": "{n} group | {n} groups",
  "nPubs": "{n} item published | {n} items published",
  "nRestrictions": "in {n} restriction | in {n} restrictions",
  "looksLike": "Looks like {tags}",
  "pick": "Choose a tag to see its players and content.",
  "newName": "New name",
  "merge": "Merge",
  "save": "Save",
  "cancel": "Cancel",
  "close": "Close",
  "rename": "Rename",
  "delete": "Delete",
  "willMerge": "“{to}” already exists: the two tags will become one.",
  "enterName": "Enter a name.",
  "tooLong": "A tag can be at most 40 characters.",
  "mergeQ": "Merge #{from} into #{to}? Players, groups, published content and restrictions move to #{to}.",
  "merged": "#{from} merged into #{to}.",
  "renamed": "#{from} renamed to #{to}.",
  "similarHint": "These tags look like the same one spelled differently. Merge them so content reaches every player.",
  "mergeInto": "Merge into #{tag}",
  "tab_players": "Players · {n}",
  "tab_groups": "Groups · {n}",
  "tab_content": "Content · {n}",
  "noPlayers": "No players have this tag.",
  "ownTag": "Own tag",
  "viaGroup": "From {name}",
  "remove": "Remove",
  "removeFromGroup": "Remove from {name}",
  "inGroups": "Change its groups",
  "removeGroupQ": "Remove #{tag} from the group {name}? Its players lose it unless they have it themselves.",
  "removedFrom": "#{tag} removed from {name}.",
  "addPlayers": "Add players",
  "addPlayersTitle": "Add players to #{tag}",
  "addPlayersHint": "The players get the tag and everything published to it.",
  "alreadyVia": "Already has it through {name}",
  "alreadyTagged": "Already has this tag",
  "addedPlayers": "#{tag} added to 1 player. | #{tag} added to {n} players.",
  "addN": "Add | Add 1 | Add {n}",
  "noGroups": "No groups have this tag.",
  "nMembers": "{n} player | {n} players",
  "addGroups": "Add groups",
  "addGroupsTitle": "Add groups to #{tag}",
  "groupHint": "Every player in a group has the group's tags.",
  "addedGroups": "#{tag} added to 1 group. | #{tag} added to {n} groups.",
  "publishedHere": "Published to this tag",
  "noPubs": "Nothing is published to this tag.",
  "reached": "On {n} player | On {n} players",
  "unpublish": "Unpublish",
  "unpublishQ": "Unpublish “{name}” from #{tag}? It is removed from 1 player. | Unpublish “{name}” from #{tag}? It is removed from {n} players.",
  "unpublished": "“{name}” unpublished from #{tag}.",
  "publishTo": "Publish content to this tag",
  "publishTitle": "Publish to #{tag}",
  "publishHint": "Every player with the tag gets it now, and players that get the tag later get it too.",
  "publishN": "Publish | Publish 1 | Publish {n}",
  "alreadyPublished": "Already published to this tag",
  "published": "1 item published to #{tag}. | {n} items published to #{tag}.",
  "restrictionsHere": "Restrictions that use this tag",
  "noRestrictions": "No restrictions use this tag.",
  "rule_playIf": "Plays only with this tag",
  "rule_dontPlayIf": "Doesn't play with this tag",
  "rule_rule": "Part of a rule",
  "everyPlayer": "On every player",
  "onGroup": "On group {name}",
  "onPlayer": "On {name}",
  "deleteQ": "Delete #{tag} everywhere? {what}",
  "impPlayers": "1 player loses it | {n} players lose it",
  "impGroups": "1 group loses it | {n} groups lose it",
  "impPubs": "1 publication ends ({items} items removed from players) | {n} publications end ({items} items removed from players)",
  "impRestrictions": "1 restriction drops it | {n} restrictions drop it",
  "impNothing": "Nothing else changes.",
  "deleted": "#{tag} deleted.",
};

const ar: typeof en = {
  "newTag": "وسم جديد",
  "newTagHint": "يبقى الوسم موجودًا ما دامت لدى مشغلات أو مجموعات. سمّه واختر من يحصل عليه.",
  "tagName": "اسم الوسم",
  "tagNamePh": "مثل: الردهة، المنطقة الشرقية",
  "groupsLabel": "مجموعات المشغلات",
  "pickSomeone": "اختر مشغلًا أو مجموعة واحدة على الأقل.",
  "alreadyExists": "#{tag} موجود بالفعل: ستُضاف إليه المشغلات والمجموعات التي تختارها.",
  "addToExisting": "إضافة إلى الوسم",
  "create": "إنشاء الوسم",
  "created": "أُنشئ #{tag}.",
  "addedExisting": "أُضيف إلى #{tag}.",
  "title": "الوسوم",
  "intro": "وسوم المشغلات تجمع المشغلات للنشر والقيود. شاهد أين يُستخدم كل وسم وغيّره في كل مكان دفعة واحدة.",
  "search": "ابحث في الوسوم",
  "lookAlikes": "وسم واحد يشبه وسمًا آخر | {n} وسوم تشبه وسومًا أخرى",
  "none": "لا توجد وسوم بعد",
  "noneHint": "أضف وسومًا إلى المشغلات أو مجموعاتها، ثم انشر المحتوى إلى وسم.",
  "noMatch": "لا توجد وسوم تطابق «{q}».",
  "nPlayers": "مشغل واحد | {n} مشغلات",
  "nGroups": "مجموعة واحدة | {n} مجموعات",
  "nPubs": "عنصر منشور واحد | {n} عناصر منشورة",
  "nRestrictions": "في قيد واحد | في {n} قيود",
  "looksLike": "يشبه {tags}",
  "pick": "اختر وسمًا لعرض مشغلاته ومحتواه.",
  "newName": "الاسم الجديد",
  "merge": "دمج",
  "save": "حفظ",
  "cancel": "إلغاء",
  "close": "إغلاق",
  "rename": "إعادة تسمية",
  "delete": "حذف",
  "willMerge": "«{to}» موجود بالفعل: سيصبح الوسمان وسمًا واحدًا.",
  "enterName": "أدخل اسمًا.",
  "tooLong": "الحد الأقصى للوسم 40 حرفًا.",
  "mergeQ": "دمج #{from} في #{to}؟ تنتقل المشغلات والمجموعات والمحتوى المنشور والقيود إلى #{to}.",
  "merged": "دُمج #{from} في #{to}.",
  "renamed": "أُعيدت تسمية #{from} إلى #{to}.",
  "similarHint": "تبدو هذه الوسوم كوسم واحد بتهجئات مختلفة. ادمجها ليصل المحتوى إلى كل المشغلات.",
  "mergeInto": "دمج في #{tag}",
  "tab_players": "المشغلات · {n}",
  "tab_groups": "المجموعات · {n}",
  "tab_content": "المحتوى · {n}",
  "noPlayers": "لا توجد مشغلات بهذا الوسم.",
  "ownTag": "وسمه الخاص",
  "viaGroup": "من {name}",
  "remove": "إزالة",
  "removeFromGroup": "إزالة من {name}",
  "inGroups": "تغيير مجموعاته",
  "removeGroupQ": "إزالة #{tag} من المجموعة {name}؟ تفقده مشغلاتها ما لم يكن لديها.",
  "removedFrom": "أُزيل #{tag} من {name}.",
  "addPlayers": "إضافة مشغلات",
  "addPlayersTitle": "إضافة مشغلات إلى #{tag}",
  "addPlayersHint": "تحصل المشغلات على الوسم وكل ما نُشر إليه.",
  "alreadyVia": "لديه بالفعل عبر {name}",
  "alreadyTagged": "لديه هذا الوسم بالفعل",
  "addedPlayers": "أُضيف #{tag} إلى مشغل واحد. | أُضيف #{tag} إلى {n} مشغلات.",
  "addN": "إضافة | إضافة 1 | إضافة {n}",
  "noGroups": "لا توجد مجموعات بهذا الوسم.",
  "nMembers": "مشغل واحد | {n} مشغلات",
  "addGroups": "إضافة مجموعات",
  "addGroupsTitle": "إضافة مجموعات إلى #{tag}",
  "groupHint": "كل مشغل في مجموعة لديه وسوم المجموعة.",
  "addedGroups": "أُضيف #{tag} إلى مجموعة واحدة. | أُضيف #{tag} إلى {n} مجموعات.",
  "publishedHere": "منشور إلى هذا الوسم",
  "noPubs": "لا شيء منشور إلى هذا الوسم.",
  "reached": "على مشغل واحد | على {n} مشغلات",
  "unpublish": "إلغاء النشر",
  "unpublishQ": "إلغاء نشر «{name}» من #{tag}؟ سيُزال من مشغل واحد. | إلغاء نشر «{name}» من #{tag}؟ سيُزال من {n} مشغلات.",
  "unpublished": "أُلغي نشر «{name}» من #{tag}.",
  "publishTo": "نشر محتوى إلى هذا الوسم",
  "publishTitle": "النشر إلى #{tag}",
  "publishHint": "يحصل عليه كل مشغل يحمل الوسم الآن، وأي مشغل يحصل على الوسم لاحقًا.",
  "publishN": "نشر | نشر 1 | نشر {n}",
  "alreadyPublished": "منشور بالفعل إلى هذا الوسم",
  "published": "نُشر عنصر واحد إلى #{tag}. | نُشرت {n} عناصر إلى #{tag}.",
  "restrictionsHere": "القيود التي تستخدم هذا الوسم",
  "noRestrictions": "لا توجد قيود تستخدم هذا الوسم.",
  "rule_playIf": "يُعرض فقط مع هذا الوسم",
  "rule_dontPlayIf": "لا يُعرض مع هذا الوسم",
  "rule_rule": "جزء من قاعدة",
  "everyPlayer": "على كل المشغلات",
  "onGroup": "على المجموعة {name}",
  "onPlayer": "على {name}",
  "deleteQ": "حذف #{tag} من كل مكان؟ {what}",
  "impPlayers": "يفقده مشغل واحد | يفقده {n} مشغلات",
  "impGroups": "تفقده مجموعة واحدة | تفقده {n} مجموعات",
  "impPubs": "ينتهي نشر واحد (تُزال {items} عناصر من المشغلات) | تنتهي {n} عمليات نشر (تُزال {items} عناصر من المشغلات)",
  "impRestrictions": "يُزال من قيد واحد | يُزال من {n} قيود",
  "impNothing": "لا يتغير شيء آخر.",
  "deleted": "حُذف #{tag}.",
};

export default { en, ar };
